import { type CampaignProductCatalogDTO, type FpB2bProductCatalogDTO } from '@cart-services/types'
import { useMemo, useState } from 'react'

export const useCategoryProductsFilter = (category: string, productCatalogDto?: CampaignProductCatalogDTO | FpB2bProductCatalogDTO) => {
  const [isFilteredByCoupon, setIsFilteredByCoupon] = useState(false)

  const toggleFilterByCoupon = () => {
    setIsFilteredByCoupon(!isFilteredByCoupon)
  }
  const currentCategoryProducts = useMemo(() => {
    const tabProducts = productCatalogDto?.products?.filter(product => product.tab_display_name === category)[0]
    const allProduct = isFilteredByCoupon
      ? tabProducts?.all_product
        .map(parentProduct => ({
          ...parentProduct,
          variations: parentProduct.variations.filter(variation => variation.coupon_ids && variation.coupon_ids.length > 0),
        }))
        .filter(parentProduct => parentProduct.variations.length > 0)
      : tabProducts?.all_product

    return {
      ...tabProducts,
      all_product: allProduct,
    }
  },
  [category, isFilteredByCoupon, productCatalogDto])

  return {
    isFilteredByCoupon,
    toggleFilterByCoupon,
    currentCategoryProducts,
  }
}
